import React from "react";
import AnimatedNumbers from "react-animated-numbers";
const AnimatedNumbersMemo = React.memo(AnimatedNumbers);

export type ScorePlateType = {
	score: number;
};
const ScorePlate: React.FC<ScorePlateType> = ({ score }) => {
	return (
		<div className="score-plate">
			<AnimatedNumbersMemo
				animateToNumber={score}
				fontStyle={{ fontSize: 28 }}
				configs={(_, index) => {
					return { mass: 0.5, tension: 130 * (index + 1), friction: 50 };
				}}
			/>
		</div>
	);
};

export default ScorePlate;
